import { TextareaField } from './TextareaField';
import { TextareaFieldWithCharCount } from './TextareaFieldWithCharCount';
import { createFormikField } from './utils/createFormikField';

export const FormikTextareaField = createFormikField(TextareaField);
export const FormikTextareaFieldWithCharCount = createFormikField(TextareaFieldWithCharCount);
